// extracted by mini-css-extract-plugin
export default {"root":"extended-label_root__c7Y-L","active":"extended-label_active__c4spb","placeHolderShimmer":"extended-label_placeHolderShimmer__8aGp-"};